import { lazy } from 'react'

import { ErrorBoundary } from '../components/ErrorBoundary'
import { RouteConfig, RouteItem } from '../types/route'

/**
 * RouteItem 转换为 RouteConfig
 *
 * @param routes 路由配置
 * @returns 路由对象
 */
const item2config = (routes: RouteItem[]): RouteConfig[] => {
  const keyIndexes: string[] = []
  const keyPaths: string[] = []

  const setKey = (data: RouteItem[]): RouteConfig[] => {
    return data.map(
      ({ path, children, element, Component, ...restRoute }, i) => {
        // 生成 0, 0-1, 0-2, 0-2-1 这样的 key
        keyIndexes.push(`${i}`)
        const key = keyIndexes.join('-')
        // 节点路径：['0', '0-2', '0-2-1']
        keyPaths.push(key)
        const keys = [...keyPaths]
        // 位置不要变
        const newChidren = children && setKey(children)
        keyPaths.pop()
        keyIndexes.pop()

        const LazyComponent = Component && lazy(Component)

        return {
          ...restRoute,
          key,
          keys,
          path,
          isPage: !!path,
          children: newChidren,
          // 设置路由元信息方便 breadcrumb 等场景使用
          handle: {
            key,
            keys
          },
          element: LazyComponent ? <LazyComponent /> : element
        }
      }
    )
  }

  return setKey(routes)
}

const translateHideAllInMenu = (routes: RouteConfig[]) => {
  const setHideInMenu = (children: RouteConfig[]) => {
    for (const child of children) {
      child.hideInMenu = true
      if (child.children) {
        setHideInMenu(child.children)
      }
    }
  }
  for (const { hideChildrenInMenu, children } of routes) {
    if (children) {
      translateHideAllInMenu(children)
      if (hideChildrenInMenu) {
        setHideInMenu(children)
      }
    }
  }
}

const setErrorBoundary = (routes: RouteConfig[]) => {
  for (const route of routes) {
    if (route.children) {
      setErrorBoundary(route.children)
      continue
    }
    if (!route.ErrorBoundary) {
      route.ErrorBoundary = ErrorBoundary
    }
  }
}

export const transformConfigs = (routes: RouteItem[]): RouteConfig[] => {
  const configs = item2config(routes)
  translateHideAllInMenu(configs)
  setErrorBoundary(configs)
  return configs
}
